import { OutlinedTextFieldProps } from '@mui/material';
import { useMemo } from 'react';
import { FormField } from 'src/components';
import { useProjectLostReasons } from 'src/graphql/entities/project-lost-reason';

export interface ProposalLostFormValues {
  projectLostReason: { id: number; label: string; value: number };
  lostReasonNotes?: string;
}

export function useProposalLostForm() {
  const { projectLostReasons, loading: isLoadingProjectLostReasons } = useProjectLostReasons();

  const proposalLostFormFields = useMemo<FormField[]>(() => {
    const commonProps: {
      textFieldProps: OutlinedTextFieldProps;
    } = {
      textFieldProps: {
        variant: 'outlined' as const,
        size: 'small',
        sx: {
          marginTop: (theme) => theme.spacing(1),
        },
      },
    };

    return [
      {
        type: 'autocomplete' as const,
        name: 'projectLostReason' as const,
        label: 'Reason',
        options: projectLostReasons.map((reason) => ({
          id: reason.id,
          label: reason.name,
          value: reason.value,
        })),
        required: 'Estimated Day1 Date is required',
        defaultValue: null,
        autocompleteProps: {
          loading: isLoadingProjectLostReasons,
        },
        textFieldProps: commonProps.textFieldProps,
      },
      {
        type: 'textfield' as const,
        name: 'lostReasonNotes',
        label: 'Additional Notes',
        defaultValue: '',
        textFieldProps: {
          ...commonProps.textFieldProps,
          InputProps: {
            multiline: true,
            minRows: 4,
          },
        },
      },
    ];
  }, [isLoadingProjectLostReasons, projectLostReasons]);

  return { proposalLostFormFields };
}
